import { render, staticRenderFns } from "./SecureImage.vue?vue&type=template&id=4a1da880"
import script from "./SecureImage.vue?vue&type=script&lang=js"
export * from "./SecureImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports